module.exports = __webpack_public_path__ + "img/a-safe-logo.0c7a0029.png";